//Название объекта должно быть в единственном числе, в конце добавляется "Enums"

export const RoleEnums = {
  // Роли пользователей
  ADMIN: 1,
  CAMP_GROUP_ADMIN: 2,
  DIRECTOR: 3,
  PARENT: 4,
  CHILD: 5,
  ORG: 6
};

export const CampTypeEnums = {
  SCHOOL_CAMP: 1,
  WORK_CAMP: 2,
  SANATORIUM: 3,
  MOTHER_SANATORIUM: 4,
  STATIONARY: 5,
  CAMPING: 6,
  INACTIVE: 7,
  CHILD_HEALTH: 8,
  prop: {
    1: {
      name: "SCHOOL_CAMP",
      text: "Лагеря при образовательных учреждениях"
    },
    2: {
      name: "WORK_CAMP",
      text: "Трудовые лагеря"
    },
    3: {
      name: "SANATORIUM",
      text: "Санатории"
    },
    4: {
      name: "MOTHER_SANATORIUM",
      text: "Санатории с возможностью размещения мать и дитя"
    },
    5: {
      name: "STATIONARY",
      text: "Стационарные лагеря"
    },
    6: {
      name: "CAMPING",
      text: "Палаточные лагеря"
    },
    7: {
      name: "INACTIVE",
      text: "Не действующие лагеря"
    },
    8: {
      name: "CHILD_HEALTH",
      text: "Детские оздоровительные лагеря"
    }
  }
};

export const CampManagerFilterEnums = {
  FREE: 0,
  ALL: 1
};
